import { TFlagChangeRequestStatus } from 'partner360/models/partnerFlagRequests/TFlagChangeRequestStatus'

export const shouldUseFlagRequest = (requestStatus?: TFlagChangeRequestStatus | null) => {
  return requestStatus !== 'Deleted' && requestStatus !== 'Approved' && requestStatus !== 'Rejected'
}
